export default __webpack_public_path__ + "static/media/content.a863b3f6.txt";